import { Typography } from "@kyan/ui";

import { Divider } from "#/components/Divider/Divider";
import { useRfqRequests } from "#/store/rfq/rfqRequests";

import { CancelRfqRequest } from "./components/CancelRfqRequest";
import { RFQLeg } from "./components/RFQLeg";

export const RFQRequests: React.FC = () => {
  const { userRfqRequests } = useRfqRequests();

  if (!userRfqRequests.length) {
    return null;
  }

  return (
    <div className="grid gap-3">
      <Divider />
      <Typography grotesk primary size={14} weight="medium">
        My RFQ Requests:
      </Typography>
      <div className="flex flex-col gap-3">
        {userRfqRequests.map((request) => (
          <div
            key={request.orderId}
            className="item-center flex justify-between"
          >
            {request.rfqOrders.map((order, index) => (
              <RFQLeg key={index} order={order} orderId={request.orderId} />
            ))}
            <CancelRfqRequest orderId={request.orderId} />
          </div>
        ))}
      </div>
    </div>
  );
};
